import { ChevronLeft, Plus, X } from "lucide-react";
import patientAvtar from "../../assets/images/default_avatar.jpg";
import { useEffect, useState } from "react";
import { PatientHistory } from "./PatientHistory";
import { PatientVitials } from "./PatientVitials";
import { PatientRecord } from "./PatientRecord";
import { UpcomingAppointment } from "../../types/appointment";
import { Link, useRouter } from "@tanstack/react-router";
import { useAuth } from "../../context/AuthContext";
import { formatAge } from "../../shared/AddNewPatientModal";
import { PatientService } from "../../services/api/patient.service";
import { PatientVitalsType, PrescriptionImagesType } from "./type";
import { PatientsUpcomingAppointments } from "./PatientsUpcomingAppointments";
interface PatientDetailsPropsType {
  onClose?: () => void;
  goToNewAppointmentModal?: () => void;
  loadAppointments?: () => void;
  setIsmarkasready?: (id: boolean) => void;
  showHistory?: boolean;
  appointment: UpcomingAppointment | null;
  destination: string;
  isTreatedPatient?: boolean;
}

export function PatientsDetails({
  selectedPatient,
  onClose,
  showHistory,
  appointment,
  loadAppointments,
  setIsmarkasready,
  destination,
  isTreatedPatient,
}: PatientDetailsPropsType) {
  const { user } = useAuth();
  const router = useRouter();
  const pathname = router.state.location.pathname
  const [currentPrescriptions, setCurrentPrescriptions] = useState<File[]>([]);
  const [onGoingPrescriptions, setOnGoingPrescriptions] = useState<PrescriptionImagesType[]>([]);
  const [selectedTab, setSelectedtab] = useState(
    showHistory ? "history" : "vitals"
  );
  const [hasVitals, setHasVitals] = useState(false);
  const [disable, setDisable] = useState(false);
  const [buttonName, setButtonName] = useState("Add vitals");
  const [isPatientAvailable, setPatientAvailable] = useState(false);
  const [currentDate, setCurrentDate] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [isPregnant,setIsPregnant]=useState(false);


  const patientId =
    selectedPatient?.userId ??
    selectedPatient?.patientId ??
    appointment?.patient_id ??
    appointment?.patientId;

  const [vitalsFormData, setVitalsFormData] = useState<PatientVitalsType>({
    patientId:
      appointment?.patient_id || appointment?.id || selectedPatient?.id || "",
    appointmentId: appointment?.id || "",
    weight: "",
    height: "",
    temperature: "",
    pulseRate: "",
    heartRate: "",
    spo2: "",
    glucose: "",
    respiratoryRate: "",
    vegetarian: "",
    bloodPressureMin: "",
    bloodPressureMax: "",
    patientConcerns: "",
    image: [],
    pregnancyMonths: "",
    fetalHeartRate:""
  });
  console.log(appointment);
useEffect(() => {
  const fetchVitals = async () => {
    try {
      setIsLoading(true);
      const [patientAvailability, vitals] = await Promise.all([
        PatientService.getPatientAvailability(selectedPatient?.userId || appointment?.patient_id || appointment?.patientId),
        PatientService.getPatientVitals(
          patientId,
          appointment?.id ?? appointment?.appointmentId,
        ),
      ]);

        if (patientAvailability.success) {
          setPatientAvailable(patientAvailability.isEditable);
        }

      if (vitals.success) {
        setVitalsFormData({
          patientId: selectedPatient?.userId ||selectedPatient?.patientId|| appointment?.patientDetails?.id || appointment?.patientId,
          appointmentId: vitals.data.appointmentId,
          weight: vitals.data.weight,
          height: vitals.data.height ?? '',
          temperature: vitals.data.temperature ?? '',
          pulseRate: vitals.data.pulseRate ?? '',
          heartRate: vitals.data.heartRate ?? '',
          spo2: vitals.data.spo2 ?? '',
          glucose: vitals.data.glucose ?? '',
          respiratoryRate: vitals.data.respiratoryRate ?? '',
          vegetarian: vitals.data.vegetarian ?? '',
          bloodPressureMin: vitals.data.bloodPressureMin ?? '',
          bloodPressureMax: vitals.data.bloodPressureMax ?? '',
          patientConcerns: vitals.data.patientConcerns ?? '',
          image: [],
          pregnancyMonths: vitals.data.pregnancyMonths ?? '',
          fetalHeartRate: vitals.data.fetalHeartRate ?? ''
        });
        setHasVitals(true);
        setDisable(true);
        setButtonName('Edit Vitals');
        setCurrentDate(vitals.data.currentDate);
        setOnGoingPrescriptions(vitals.data.ongoingMedication)
        if(vitals.data.pregnancyMonths){
          setIsPregnant(true);
        }
      }
    } catch (error) {
      console.log('error', error);
    } finally {
      setIsLoading(false);
    }
  };
  fetchVitals();
}, [appointment, patientId, selectedPatient?.patientId, selectedPatient?.userId, user]);
  return (
    <section className="w-full pb-2">
      {showHistory ? (
        <>
          <h3 className={`flex items-center justify-start gap-4`}>
            <button
              className="w-8 h-8 flex items-center justify-center text-red-600 rounded-full"
              style={{ backgroundColor: "#F6F6F6" }}
              onClick={onClose}
            >
              <ChevronLeft className="w-6 h-6" />
            </button>
            <span className="font-semibold text-lg">Patient Details</span>
          </h3>
        </>
      ) : (
        <h3
          className={`rounded-t-md w-full flex items-center justify-between bg-white p-2`}
        >
          <span className="font-semibold text-lg text-[#199C4D]">
            Patient Details
          </span>
          <button
            className="w-8 h-8 flex items-center justify-center  text-red-600 "
            onClick={onClose}
          >
            <X className="w-6 h-6" />
          </button>
        </h3>
      )}

      <div
        className={`w-full  bg-white min-h-[75dvh] ${
          showHistory
            ? "my-3 rounded-md border border-gray-300"
            : "rounded-b-md"
        }`}
      >
        {/* Profile and Patients normal Details with two buttons */}
        <div className="w-full p-2 py-4 rounded-t-md flex items-center justify-between">
          <div className="flex items-center justify-start gap-3">
            <div className="w-14 h-14 border border-gray-200 rounded-full overflow-hidden">
              <img
                src={
                  appointment?.patientDetails?.profileImage ||
                  selectedPatient?.profileImage ||
                  appointment?.patientprofile ||
                  patientAvtar
                }
                alt={
                  appointment?.patientDetails?.name ||
                  appointment?.name ||
                  "Patient Profile"
                }
                className="w-full h-full object-cover"
              />
            </div>
            <div className="flex items-start justify-center flex-col ">
              <span className="font-bold text-lg">
                {appointment?.patientDetails?.name ||
                  selectedPatient?.name ||
                  appointment?.name ||
                  "N/A"}
              </span>
              <p className="flex items-center justify-center gap-4">
                <span className="text-gray-600 text-sm">
                  {appointment?.patientDetails?.mobileNumber ||
                    selectedPatient?.mobileNumber || selectedPatient?.mobilenumber ||
                    appointment?.mobilenumber ||
                    "N/A"}
                </span>
                <span className="text-gray-600 text-sm">
                  Age: &nbsp;
                  {formatAge(
                    appointment?.patientDetails?.age ||
                      selectedPatient?.age ||
                      appointment?.age ||
                      "N/A"
                  )}
                </span>
                <span className="text-gray-600 text-sm">
                  {appointment?.patientDetails?.gender ||
                    selectedPatient?.gender ||
                    appointment?.gender ||
                    "N/A"}
                </span>
                <span className="text-gray-600 text-sm">
                  {showHistory ? (
                    <>{selectedPatient?.registeredDate || ""}</>
                  ) : (
                    <>Follow Up</>
                  )}
                </span>
              </p>
            </div>
          </div>

          <div className="px-2 flex items-center justify-center gap-5">
            {showHistory ? (
              <>
                {(appointment?.appointment_date ||
                  appointment?.appointmentTime) && (
                  <p className="select-none rounded flex items-center justify-center p-2 px-4 bg-gray-300/40">
                    {appointment?.appointment_date ||
                      appointment?.appointmentTime}
                  </p>
                )}

                {user?.role !== "admin" && (
                  <Link
                    to="/clinic/appointments"
                    state={{
                      mobileNumber: selectedPatient?.mobileNumber,
                      isModalOpen: true,
                    }}
                    className="hover:bg-emerald-700 transition-colors rounded-md flex items-center justify-center gap-2 p-2 bg-emerald-600 text-white font-semibold capitalize"
                  >
                    <Plus className="w-4 h-4" />
                    Schedule Appointment
                  </Link>
                )}
              </>
            ) : (
              <>
                <p className=" text-[#199C4D] border border-[#199C4D40]  select-none rounded-full flex items-center justify-center p-2 px-4 bg-white">
                  {appointment?.appointment_date?.split("T")[0] ||
                    appointment?.appointmentTime?.split("T")[0]}
                </p>
              </>
            )}
          </div>
        </div>

        {/* Tabs  */}
        <div className="bg-gray-100 h-[50px] flex items-center justify-start gap-8 px-4">
          {showHistory && (
            <button
              onClick={() => setSelectedtab("history")}
              className={`${
                selectedTab === "history"
                  ? "text-red-600 border-red-600"
                  : "border-gray-100"
              } border-b-2 h-full text-sm font-medium `}
            >
              Patient History
            </button>
          )}
          {!showHistory && (
            <>
              <button
                onClick={() => setSelectedtab("vitals")}
                className={`${
                  selectedTab === "vitals"
                    ? "text-red-600 border-red-600"
                    : "border-gray-100"
                } border-b-2 h-full text-sm font-medium`}
              >
                Patient Vitals
              </button>
            </>
          )}
          <button
            onClick={() => setSelectedtab("record")}
            className={`${
              selectedTab === "record"
                ? "text-red-600 border-red-600"
                : "border-gray-100"
            } border-b-2 h-full text-sm font-medium`}
          >
            Health Record
          </button>
          { pathname === "/clinic/patients" && <button
            onClick={() => setSelectedtab("upcoming")}
            className={`${
              selectedTab === "upcoming"
                ? "text-red-600 border-red-600"
                : "border-gray-100"
            } border-b-2 h-full text-sm font-medium`}
          >
            Upcoming Appointments
          </button>}
        </div>

        <div className="py-4 px-3">
          {selectedTab === "history" && (
            <PatientHistory patient={selectedPatient} />
          )}

          {selectedTab === "vitals" && (
            <PatientVitials
              disableAccess={showHistory}
              appointment={appointment}
              patient={selectedPatient}
              loadAppointments={loadAppointments}
              onClose={onClose}
              setIsmarkasready={setIsmarkasready}
              destination={destination}
              vitalsFormData={vitalsFormData}
              setVitalsFormData={setVitalsFormData}
              currentPrescriptions={currentPrescriptions}
              setCurrentPrescriptions={setCurrentPrescriptions}
              onGoingPrescriptions={onGoingPrescriptions}
              setOnGoingPrescriptions={setOnGoingPrescriptions}
              hasVitals={hasVitals}
              setHasVitals={setHasVitals}
              buttonName={buttonName}
              setButtonName={setButtonName}
              disable={disable}
              setDisable={setDisable}
              isPatientAvailable={isPatientAvailable}
              currentDate={currentDate}
              isLoading={isLoading}
              setIsLoading={setIsLoading}
              isTreatedPatient={isTreatedPatient}
              isPregnant={isPregnant}
              setIsPregnant={setIsPregnant}
            />
          )}
          {selectedTab === "record" && (
            <PatientRecord
              editAccess={showHistory}
              appointment={appointment}
              patient={selectedPatient}
              isTreatedPatient={isTreatedPatient}
            />
          )}
          {selectedTab === "upcoming" && (
            <PatientsUpcomingAppointments
              patient={selectedPatient}
            />
          )}
        </div>
      </div>
    </section>
  );
}

export default PatientsDetails;